export default __webpack_public_path__ + "static/media/deal-10.8f3fc2d9.webp";